
import { computed, defineComponent } from 'vue';
import dayjs from 'dayjs';

export default defineComponent({
  name: 'PointInfoExpire',

  props: {
    point: {
      type: Number,
      default: null,
    },
  },

  setup() {
    const endOfMonth = computed(() => dayjs().endOf('month').format('YYYY/MM/DD'));

    return { endOfMonth };
  },
});
